import React from "react";

const Home = () => {
  return (
    <div>
      <h1>Welcome to My React App</h1>
      <p>coming soon</p>
    </div>
  );
};

export default Home;
